import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { Footer } from "@/components/landing/Footer";

export const LegalSection = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl font-semibold tracking-tight text-[var(--olive-deep)]">
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-[var(--ink-soft)]">
      {children}
    </div>
  </section>
);

export const LegalLayout = ({ title, updated, testId, children }) => (
  <div data-testid={testId} className="min-h-screen bg-[var(--cream)]">
    <header className="border-b border-[#eadfd2] bg-[var(--cream)]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="legal-logo-link">
          <img src={ASSETS.logo} alt="Domaya logo" className="h-9 w-9 rounded-lg object-cover" />
          <span className="font-display text-xl font-semibold text-[var(--olive-deep)]">Domaya</span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-[var(--ink-soft)] transition-colors hover:text-[var(--olive)]"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-3xl px-6 py-16">
      <h1 className="font-display text-4xl font-semibold tracking-tight text-[var(--ink)] sm:text-5xl">
        {title}
      </h1>
      <p className="mt-3 text-sm text-[var(--ink-soft)]">Last updated: {updated}</p>
      {children}
    </main>

    <Footer />
  </div>
);
